/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, Input, OnChanges, SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItem } from '../types';

@Component({
  selector: 'bulb-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: false,
})
export class MenuItemComponent implements OnChanges {
  inputChange = new Subject();

  @Input() menuItem: MenuItem;

  /**
   * Opens a link in a new tab if the user clicks the descriptive icon and descriptiveIconURL isn't null.
   * @param event to stop propagation to the button click bellow the icon.
   */
  openDescriptiveIconLink(event: any) {
    if (this.menuItem.descriptiveIconURL) {
      window.open(this.menuItem.descriptiveIconURL, '_blank').focus();
      event.stopPropagation();
    }
  }

  ngOnChanges(model: SimpleChanges) {
    this.inputChange.next(model);
  }
}
